<div
    class="container" [ngClass]="typePopup"
    [style.width.vw]="width"
    [@showHide]="{ value: animationState, params: { height: height } }"
    (@showHide.start)="onShowHide($event)"
    (@showHide.done)="onShowHide($event)"
>
    <aa-colored-popup-menu-item
        *ngFor="let popupMenuItem of popupMenuItems"
        class="popitem"
        [typePopup]="typePopup"
        [popupMenuItem]="popupMenuItem"
    ></aa-colored-popup-menu-item>
</div>
